import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  CircularProgress,
} from '@mui/material'
import { BillStatus } from '@services/dtos'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: (status: BillStatus) => Promise<void>
}

const BillStatusDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => {
  const [selectedStatus, setSelectedStatus] = useState<BillStatus>(
    BillStatus.PAID,
  )
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (open) {
      setSelectedStatus(BillStatus.PAID)
      setIsSubmitting(false)
    }
  }, [open])

  const handleConfirm = async () => {
    setIsSubmitting(true)
    try {
      await onConfirm(selectedStatus)
      onClose()
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleClose = () => {
    if (!isSubmitting) {
      setSelectedStatus(BillStatus.PAID)
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Statut de facturation</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Veuillez sélectionner le statut de paiement pour cette commande
        </Typography>
        <RadioGroup
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value as BillStatus)}
        >
          <FormControlLabel
            value={BillStatus.PAID}
            control={<Radio />}
            label="Payé"
          />
          <FormControlLabel
            value={BillStatus.PARTIALLY_PAID}
            control={<Radio />}
            label="Partiellement payé"
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>
          Annuler
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting && (
            <CircularProgress size={18} sx={{ mr: 1, color: 'grey.500' }} />
          )}
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BillStatusDialog
